import { type Dayjs } from 'dayjs';
import { useCallback, useMemo } from 'react';
import { useConfigs } from '../queries';
import { isNil } from '../utils';

export const useGetNextWorkingDay = (date: Dayjs | null) => {
  const { data: configs } = useConfigs();

  const getNextWorkingDay = useCallback((target: Dayjs) => {
    const time = target;
    // 금요일이면,
    if (time.day() === 5) {
      return time.add(3, 'days');
    }
    // 토요일이면,
    if (time.day() === 6) {
      return time.add(2, 'days');
    }
    // 평일이거나 일요일이면,
    return time.add(1, 'days');
  }, []);

  const targetDay = useMemo(() => {
    if (date === null) return null;

    return getNextWorkingDay(date);
  }, [date, getNextWorkingDay]);

  const holidays = useMemo<{ [key: string]: boolean }>(() => {
    return (
      configs?.delivery_holidays.reduce((acc, cur) => {
        return {
          ...acc,
          [cur]: true,
        };
      }, {}) ?? {}
    );
  }, [configs?.delivery_holidays]);

  return useMemo(() => {
    if (isNil(targetDay)) return null;

    const targetDayText = targetDay.format('YYYY-MM-DD');
    if (holidays[targetDayText]) {
      //이때 마침 이 날이 금요일이라면 ?
      return getNextWorkingDay(targetDay);
    }

    return targetDay;
  }, [getNextWorkingDay, holidays, targetDay]);
};
